"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFlag = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconFlag = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "32",
    height: "40",
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M2.97014 38.8725C2.97014 39.4919 2.30207 40 1.48507 40C0.668024 40 0 39.4919 0 38.8725L0.00156808 1.12753C0.00156808 0.508083 0.669632 0 1.48664 0C2.30368 0 2.9717 0.508083 2.9717 1.12753L2.97014 38.8725Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.4309 13.7405C13.2197 14.2674 12.1142 14.5057 9.90283 14.4603V8.93225C12.114 8.9793 13.2211 8.73936 15.4309 8.214V13.7405V13.7405Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M20.959 6.77803C18.7478 7.30338 17.6423 7.686 15.4309 8.21292V2.68366C17.642 2.15674 18.7476 1.77412 20.959 1.25034V6.77839V6.77803Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M26.4882 11.5955C24.2755 11.5438 23.17 11.7837 20.959 12.3075V6.7782C23.1701 6.25286 24.2757 6.01451 26.4882 6.06626V11.5955Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M20.959 17.8354C18.7478 18.3607 17.6423 18.7433 15.4309 19.2687V13.7406C17.642 13.2137 18.7476 12.8326 20.959 12.3073V17.8354Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M30.8978 1.46958C30.6563 1.36922 30.5355 1.32217 30.294 1.23749C29.2104 0.854857 28.6663 0.743501 27.5826 0.629046C27.1451 0.583569 26.9256 0.571023 26.488 0.560043V1.65622V2.25997V4.36762V4.97137V6.06754C26.9255 6.07695 27.1451 6.09107 27.5826 6.13655C27.8241 6.16164 27.9449 6.17732 28.1864 6.21495C29.0301 6.34512 29.4503 6.44705 30.294 6.745C30.5355 6.82968 30.6563 6.87672 30.8978 6.97709C31.3369 7.16057 31.5549 7.26407 31.994 7.50087V6.40469V3.69329V3.08954C31.994 2.48423 31.5015 1.7221 30.8978 1.46959V1.46958Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M30.8978 18.0076C30.6563 17.9072 30.5355 17.8617 30.294 17.7755C29.2104 17.3929 28.6663 17.2815 27.5826 17.167C27.1451 17.1216 26.9256 17.1074 26.488 17.098V16.0019V15.3997V13.2905V12.6883V11.5921C26.9255 11.6015 27.1451 11.6156 27.5826 11.6611C27.8241 11.6862 27.9449 11.7019 28.1864 11.7395C29.0301 11.8697 29.4519 11.97 30.2956 12.268C30.5371 12.3542 30.6563 12.3997 30.8978 12.5001C31.3369 12.682 31.5549 12.7871 31.994 13.0239V14.12V16.8314V17.4352C31.994 18.0405 31.5015 18.2601 30.8978 18.0076V18.0076Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.46998 19.0787C5.71148 19.179 5.83067 19.2261 6.07373 19.3108C7.15734 19.6934 7.69995 19.8048 8.78513 19.9192C9.22424 19.9647 9.44219 19.9772 9.88131 19.9882V18.892V18.2883V16.1806V15.5769V14.4807C9.4438 14.4697 9.22424 14.4572 8.78669 14.4117C8.54519 14.3866 8.42444 14.3709 8.18294 14.3333C7.33924 14.2031 6.91743 14.1028 6.0753 13.8048C5.8338 13.7186 5.71305 13.6731 5.47155 13.5727C5.03243 13.3908 4.81448 13.2858 4.37537 13.049V14.1451V16.8565V17.4603C4.3738 18.064 4.86623 18.8261 5.46998 19.0786V19.0787Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.46998 2.5391C5.71148 2.63947 5.83067 2.68651 6.07373 2.77119C7.15734 3.15383 7.69995 3.26362 8.78513 3.37964C9.22424 3.42512 9.44219 3.43923 9.88131 3.44864V4.54325V5.147V7.25465V7.8584V8.95458C9.4438 8.9436 9.22424 8.93106 8.78669 8.88558C8.54519 8.86049 8.42444 8.84481 8.18294 8.80717C7.33924 8.67701 6.91743 8.57508 6.0753 8.27713C5.8338 8.19245 5.71305 8.1454 5.47155 8.04504C5.03243 7.86156 4.81292 7.75806 4.37537 7.52126V6.42508V3.71525V3.1115C4.3738 2.50775 4.86623 2.28819 5.46998 2.5391Z",
      fill: color
    }, void 0)]
  }), void 0);
});